import axios from "axios";
import auth from "../auth/auth";
import authDir from "../auth/authDirecto";
import store from "@/store";

const baseUrl = process.env.VUE_APP_API_URL;
const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    // "Access-Control-Allow-Credentials": true,
    "ngrok-skip-browser-warning": "1234"
  }
});

let refreshPromise = null;

const shouldSkipRefresh = (config = {}) => {
  const url = config.url || "";

  return (
    config._retry ||
    url.includes("authenticate") ||
    url.includes("verify-2fa") ||
    url.includes("refresh-token") ||
    url.includes("login")
  );
};

api.interceptors.request.use(async (config) => {
  let token = null;
  let tokenDir = null;
  if (auth.isAuthenticated()) {
    token = auth.getUserLogged()?.token;
  }
  if (authDir.isAuthenticated()) {
    tokenDir = authDir.getUserLogged()?.token;
  }
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  if (tokenDir) {
    config.headers["authorization-payment"] = "Bearer " + tokenDir;
  }
  return config;
});
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error("error: ", error);
    const originalRequest = error.config;
    // if (error.response.status == 429) {
    // store.dispatch("mostrarAlerta", {
    //   mensaje: error.response.data,
    //   color: "error"
    // });
    // }

    if (
      error.response?.status === 401 &&
      auth.isAuthenticated() &&
      !shouldSkipRefresh(originalRequest)
    ) {
      originalRequest._retry = true;

      try {
        if (!refreshPromise) {
          refreshPromise = auth
            .refreshAccessToken()
            .then((response) => auth.updateUserAccessToken(response.data))
            .finally(() => {
              refreshPromise = null;
            });
        }

        const userLogged = await refreshPromise;
        originalRequest.headers.Authorization = "Bearer " + userLogged.token;
        return api(originalRequest);
      } catch (refreshError) {
        store.dispatch("mostrarAlerta", {
          mensaje: "Su sesión ha expirado, por favor vuelva a iniciar sesión.",
          color: "error"
        });
        await auth.cerrarSesion();
        return Promise.reject(refreshError);
      }
    }

    if (error.response?.status === 401) {
      store.dispatch("mostrarAlerta", {
        mensaje: "Su sesión ha expirado, por favor vuelva a iniciar sesión.",
        color: "error"
      });
      auth.cerrarSesion();
    }
    return Promise.reject(error);
  }
);
export default api;
